import { Component, ChangeDetectionStrategy, input, computed, inject, output, signal } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { CommonModule } from '@angular/common';
import { Wallet } from '../../models/wallet.model';
import { FormsModule } from '@angular/forms';
import { InputText } from "primeng/inputtext"
@Component({
  selector: 'spike-wallet-list',
  templateUrl: './wallet-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule, InputText]
})
export class WalletListComponent extends AbstractComponent {
  list = input.required<Wallet[]>();
  onSelect = output<Wallet>();

  public filter = signal<string>('');

  public readonly filteredList = computed(()=>{
    const list = this.list();
    const filter = this.filter();
    return list.filter(x=> x.shortDescription.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) );
  })

  private debounceTimeout?: any;
  updateFilter(searchKey: string) {
    console.log(searchKey)
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      this.filter.set(searchKey);
    }, 300);

  }
  

}
